import { AnalyticIdentifier, isProductionLikeEnvironment } from '@common/neo.tax';
import { useEffect } from 'react';

import { env } from '@neo.tax/shared/utils';

import { addAnalyticIdsVar, AnalyticIdOptions, deleteAnalyticIdsVar, makeCompoundAnalyticId } from '../analyticIdsVar';

export const useAnalyticId = (id: AnalyticIdentifier, options?: AnalyticIdOptions): string => {
  const internalId = makeCompoundAnalyticId(id, options);

  useEffect(() => {
    if (!isProductionLikeEnvironment(env.REACT_APP_NEO_TAX_ENV)) {
      addAnalyticIdsVar(id, options);
    }

    return (): void => {
      deleteAnalyticIdsVar(id, options);
    };
  }, [id, options]);

  return internalId;
};
